import styled from "@emotion/styled"
import { css } from "@emotion/react"
import getMediaQuery, { media } from "css/breakpoints"
import { wv_willfade, wv_imgheight } from "./../styles"

const revealOffset = 0.9

const SCROLLxN = new Map([
  [2, [50, 0.9]],
  [3, [33.3333, .9]],
  [13, [33.3333, 1]],
  [23, [33.3333, .8]],
  [4, [25, 1]],
  [5, [20, 1]],
])

function x(v) {
  return css`
    &:before,
    &:after {
      content: "";
      flex: 0 0 ${(100 - SCROLLxN.get(v)[0] * SCROLLxN.get(v)[1]) / 2}%;
    }
    & li {
      flex: 0 0 ${SCROLLxN.get(v)[0] * SCROLLxN.get(v)[1]}%;
    }
    --wv-step-div: ${v % 10};
    --wv-step-offset: ${SCROLLxN.get(v)[1]};
  `
}

export const Main = styled.section`
  --spacing: 3.125rem;
  .wvIncard & {
    --spacing: var(--gv-padding-inline);
  }
  ${wv_willfade}
  &.wv_reveal {
    & ul {
      scroll-behavior: smooth;
    }
  }
  position: absolute;
  width: 100%;
  @media (hover: hover) and (pointer: fine) {
    left: var(--spacing);
    width: calc(100% - 2 * var(--spacing));
  }
  top: 0;
  left: 0;
  ${wv_imgheight}
  //  background: rgba(0, 255, 255, 0.4);
  user-select: none;

  & ul {
    height: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    scrollbar-width: none;
    scroll-behavior: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    scroll-snap-type: x mandatory;
    justify-items: center;

    & li {
      cursor: pointer;
      scroll-snap-align: center;
      height: 100%;
      flex: 0 0 25%;
      position: relative;
      overflow: hidden;
      will-change: opacity;

      @media (hover: hover) and (pointer: fine) {
        &[aria-current="false"]:hover {
          cursor: pointer;
          figcaption {
            opacity: 1;
            transition: opacity 1s cubic-bezier(0.23, 1, 0.32, 1) 0.3s;
          }
        }
      }

      & figure {
        position: relative;
        height: 100%;

        & img {
          pointer-events: none;
          display: block;
          position: absolute;
          height: 100%;
          width: auto;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          object-fit: cover;
          [dir="rtl"] & {
            left: auto;
            right: 50%;
            transform: translateX(50%);
          }
        }

        font-size: clamp(0.875rem, 0.8125rem + 0.1563vw, 1rem); // 14px > 16px
        line-height: 1;

        & figcaption {
          position: absolute;
          transform: translateZ(0);
          left: 0;
          top: 70%;
          width: 100%;
          text-align: center;
          opacity: 0;
          font-size: 0.8em;

          .wv_step_4 & {
            top: 92%;
          }
        }
      }
    }

    ${x(2)}
    .wvIncard & {
      ${x(13)}
    }

    @media (min-width: 481px) {
      .wvIncard & {
        ${x(3)}
      }
    }

    @media (min-width: 960px) {
      ${x(4)}
    }

    @media (hover: hover) and (pointer: fine) {
      ${x(13)}
    }

    @media (min-width: 768px) and (hover: hover) and (pointer: fine) {
      ${x(3)}
    }

    @media (min-width: 1024px) and (hover: hover) and (pointer: fine) {
      .wvIncard & {
        ${x(23)}
      }
    }
  }
`
